import '../../constants/icons/index.mjs';
import { ExternalUrl } from '../../constants/url.mjs';
import { SiteId } from '../MenuContext/mapping.mjs';
import './assets/index.mjs';
import { Language } from '../../types/constants.mjs';
import _externalAssets_Dk2JA8RU__default from "../../assets/cloud-gateway-overview.png";
import _externalAssets_CRacVtRZ__default from "../../assets/overview.svg";
import _externalAssets_YjP0T2_m__default from "../../assets/enterprise-scale.png";
import _externalAssets_Zpt8loyO__default from "../../assets/efg.svg";
import _externalAssets_BH8DUKdC__default from "../../assets/large-scale.png";
import _externalAssets_C$asv5Oy__default from "../../assets/dreamMachineStacked.svg";
import _externalAssets_CaCLscTQ__default from "../../assets/compact.png";
import _externalAssets_BRM6VTe5__default from "../../assets/ultra-cloud-gateway.svg";
import _externalAssets_DQOzpFZx__default from "../../assets/wifi-integrated.png";
import _externalAssets_CI9fPBZA__default from "../../assets/wifiIntegrated.svg";
import _externalAssets_qKb7Hnlz__default from "../../assets/identity.png";
import _externalAssets_DuW6B0XT__default from "../../assets/identity.svg";
import _externalAssets_BbXnDXBd__default from "../../assets/switching-overview.png";
import _externalAssets_B8_Qr_az__default from "../../assets/aggregation.png";
import _externalAssets_Cx9aj6Rn__default from "../../assets/swEnterprise.svg";
import _externalAssets_BSkw9Zkq__default from "../../assets/multi-gbe.png";
import _externalAssets_B0X_t3Jf__default from "../../assets/swProMax.svg";
import _externalAssets_BfjuZnZh__default from "../../assets/single-gbe.png";
import _externalAssets_BbFiyURO__default from "../../assets/swProMax.svg";
import _externalAssets_CIbMEIAi__default from "../../assets/compact-switching.png";
import _externalAssets_Dn54mv2t__default from "../../assets/swCompact.svg";
import _externalAssets_Cpm3n_eb__default from "../../assets/wifi-overview.png";
import _externalAssets_3KklAuCo__default from "../../assets/e7.png";
import _externalAssets_DqAIRBTt__default from "../../assets/wifiE7.svg";
import _externalAssets_zRUCu0IR__default from "../../assets/wifi-flagship.png";
import _externalAssets_BpAHE3Kz__default from "../../assets/flagship.svg";
import _externalAssets_D1txdweP__default from "../../assets/wifi-wall.png";
import _externalAssets_NhqTXzWJ__default from "../../assets/inWall.svg";
import _externalAssets_C3btxvT0__default from "../../assets/wifi-outdoor.png";
import _externalAssets_DoUzeQKl__default from "../../assets/flexibleOutdoor.svg";
import _externalAssets__VZ6$rD9__default from "../../assets/wifi-bridging.png";
import _externalAssets_CqhVoPUD__default from "../../assets/bridging.svg";
import _externalAssets_hkQRamuJ__default from "../../assets/wifi.svg";
import _externalAssets_CQnDr0KZ__default from "../../assets/security-overview.png";
import _externalAssets_DSCcAWv8__default from "../../assets/dome-turret.png";
import _externalAssets_D2$2b9Kg__default from "../../assets/domeTurret.svg";
import _externalAssets_DXDhtbGS__default from "../../assets/bullet.png";
import _externalAssets_CJUPKRFm__default from "../../assets/bullet.svg";
import _externalAssets_hQ45m3sS__default from "../../assets/ptz.png";
import _externalAssets_BhTWNUe$__default from "../../assets/ptz.svg";
import _externalAssets_BJ4JezH6__default from "../../assets/doorbells.svg";
import _externalAssets_TWdDoFCP__default from "../../assets/compact-cameras.svg";
import _externalAssets_B4KkF36C__default from "../../assets/ai-enhancements.svg";
import _externalAssets_CgJ1WmE4__default from "../../assets/superlink.svg";
import _externalAssets_CtJPud52__default from "../../assets/floodlight2.svg";
import _externalAssets_C_DozlA4__default from "../../assets/camera-special-devices.png";
import _externalAssets_h17pgRRZ__default from "../../assets/special-devices.svg";
import _externalAssets_2tUH2ymR__default from "../../assets/video-recorders.png";
import _externalAssets_T7rpQKbk__default from "../../assets/nvr.svg";
import _externalAssets_COisoUzw__default from "../../assets/door-access.png";
import _externalAssets_YNBtLHei__default from "../../assets/doorAccess.svg";
import _externalAssets_B_OBU6a1__default from "../../assets/physical-security-category.svg";
import _externalAssets_DNTZveo7__default from "../../assets/unas.png";
import _externalAssets_CSNKwvWT__default from "../../assets/unas.svg";
import _externalAssets_iKcTrPwm__default from "../../assets/ups.svg";
import _externalAssets_CVgHVDx___default from "../../assets/power-solutions.svg";
import _externalAssets_Cejg$63X__default from "../../assets/ups.png";
import _externalAssets_B_Cc27E8__default from "../../assets/managed-voip.png";
import _externalAssets_DPMNLIio__default from "../../assets/phones.svg";
import _externalAssets_C5MQ_jlG__default from "../../assets/mobile-routing.png";
import _externalAssets_GYevzP4Z__default from "../../assets/mobileRouting.svg";
import _externalAssets_ChdEjBXM__default from "../../assets/evCharging.svg";
import _externalAssets_Dr1plcD3__default from "../../assets/digitalSignage.svg";
import _externalAssets_Gz$V$WE1__default from "../../assets/premiumAudio.svg";
import _externalAssets_S4hTCKE4__default from "../../assets/premium-iot.png";
import _externalAssets_ChZQegFt__default from "../../assets/premiumIot.svg";
import _externalAssets_Ds50mgmi__default from "../../assets/controlPlaneOptions.svg";
import _externalAssets_pJK9fPl1__default from "../../assets/independentGateways.svg";
import _externalAssets_BmQlds8B__default from "../../assets/hosting.png";
import _externalAssets_PsHlg1yq__default from "../../assets/hosting.svg";
import _externalAssets_Qic4gR$c__default from "../../assets/accessories.svg";
import _externalAssets_BnbVVkSu__default from "../../assets/power-tech.png";
import _externalAssets_CjfieAUH__default from "../../assets/lteBackupIcon.svg";
import _externalAssets_B5qDlu7O__default from "../../assets/internet-solutions.svg";
import _externalAssets_DM_B33LN__default from "../../assets/sfp-wizard.svg";
import _externalAssets_Cw_GgD14__default from "../../assets/accessory-tech.png";
import _externalAssets_Ch5r_E58__default from "../../assets/accessory-tech.svg";
import _externalAssets_DJwY3ZXh__default from "../../assets/integrations.svg";
import _externalAssets_DvVFinxL__default from "../../assets/simple.png";
import _externalAssets_DiR0ROIn__default from "../../assets/large.png";
import _externalAssets_CQoXW_3n__default from "../../assets/massive-scale.png";
import _externalAssets_vCVJ4SZf__default from "../../assets/multi-site.png";
import _externalAssets_QVv40$gv__default from "../../assets/design-center.png";
import _externalAssets_C7zqcGfq__default from "../../assets/techspecs.png";
import _externalAssets_d0LZ7dCX__default from "../../assets/professional-support.png";
import _externalAssets_BAbiNnXu__default from "../../assets/blog.png";
import _externalAssets_BQseNU0v__default from "../../assets/events-and-programs.png";
import _externalAssets_DeS__lyD__default from "../../assets/training.png";
import _externalAssets_CyrW3sxr__default from "../../assets/partner-hub.png";
import _externalAssets_CAFWLGY5__default from "../../assets/case-studies-overview.jpg";
import _externalAssets_DUdtRT_2__default from "../../assets/shopify-summit.jpg";
import _externalAssets_BZ1iDGY4__default from "../../assets/tiny-dino.jpg";
import _externalAssets_DpNYEVxS__default from "../../assets/celtic-doyle.jpg";
import _externalAssets_r$Gidefk__default from "../../assets/fedex-forum.jpg";
"use strict";
const DEFAULT_LANGUAGE = Language.En;
var MenuItemId = /* @__PURE__ */(MenuItemId2 => {
  MenuItemId2["SiteMap"] = "start-here-site-map";
  MenuItemId2["HowItWorks"] = "start-here-why-unifi";
  return MenuItemId2;
})(MenuItemId || {});
const START_HERE_ID = "start-here";
var MenuCategoryId = /* @__PURE__ */(MenuCategoryId2 => {
  MenuCategoryId2["CloudGateways"] = "cloud-gateways";
  MenuCategoryId2["Switching"] = "switching";
  MenuCategoryId2["WiFi"] = "wifi";
  MenuCategoryId2["PhysicalSecurity"] = "physical-security";
  MenuCategoryId2["Integrations"] = "integrations";
  return MenuCategoryId2;
})(MenuCategoryId || {});
const SHARED_MENU_ITEMS = [{
  id: "cloud-gateways" /* CloudGateways */,
  label: "menu.label.cloudGateways",
  description: "menu.description.cloudGateways",
  items: [{
    id: "cloud-gateways-overview",
    label: "commons.menu.label.overview",
    isOverview: true,
    hasDarkText: false,
    description: "menu.label.cloudGateways.overview.description",
    collapsedLabel: "menu.label.cloudGateways.overview",
    icon: {
      src: _externalAssets_CRacVtRZ__default,
      height: 20,
      width: 32
    },
    image: {
      src: _externalAssets_Dk2JA8RU__default,
      width: 132,
      height: 80
    },
    url: [SiteId.Ui, "/cloud-gateways"]
  }, {
    id: "cloud-gateways-enterprise-scale",
    label: "menu.label.cloudGateways.enterpriseScale",
    description: "menu.label.cloudGateways.enterpriseScale.description",
    url: [SiteId.Ui, "/cloud-gateways/enterprise-scale"],
    isNew: true,
    icon: {
      src: _externalAssets_Zpt8loyO__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_YjP0T2_m__default,
      width: 132,
      height: 80
    }
  }, {
    id: "cloud-gateways-large-scale",
    label: "menu.label.cloudGateways.largeScale",
    description: "menu.label.cloudGateways.largeScale.description",
    url: [SiteId.Ui, "/cloud-gateways/large-scale"],
    isNew: true,
    icon: {
      src: _externalAssets_C$asv5Oy__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_BH8DUKdC__default,
      width: 132,
      height: 80
    }
  }, {
    id: "cloud-gateways-compact",
    label: "menu.label.cloudGateways.compact",
    description: "menu.label.cloudGateways.compact.description",
    url: [SiteId.Ui, "/cloud-gateways/compact"],
    isNew: true,
    icon: {
      src: _externalAssets_BRM6VTe5__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_CaCLscTQ__default,
      width: 132,
      height: 80
    }
  }, {
    id: "cloud-gateways-wifi-integrated",
    label: "menu.label.cloudGateways.wifiIntegrated",
    description: "menu.label.cloudGateways.wifiIntegrated.description",
    url: [SiteId.Ui, "/cloud-gateways/wifi-integrated"],
    icon: {
      src: _externalAssets_CI9fPBZA__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_DQOzpFZx__default,
      width: 132,
      height: 80
    }
  }, {
    id: "cloud-gateways-identity",
    label: "menu.label.cloudGateways.identity",
    description: "menu.label.cloudGateways.identity.description",
    url: [SiteId.Ui, "/identity"],
    isNew: false,
    icon: {
      src: _externalAssets_DuW6B0XT__default,
      width: 32,
      height: 32
    },
    image: {
      src: _externalAssets_qKb7Hnlz__default,
      width: 132,
      height: 80
    }
  }]
}, {
  id: "switching" /* Switching */,
  label: "menu.label.switching",
  description: "menu.description.switching",
  items: [{
    id: "switching-overview",
    label: "commons.menu.label.overview",
    collapsedLabel: "menu.label.switching.overview",
    description: "menu.label.switching.overview.description",
    isOverview: true,
    hasDarkText: false,
    url: [SiteId.Ui, "/switching"],
    icon: {
      src: _externalAssets_CRacVtRZ__default,
      height: 20,
      width: 32
    },
    image: {
      src: _externalAssets_BbXnDXBd__default,
      width: 132,
      height: 80
    }
  }, {
    id: "switching-enterprise",
    label: "menu.label.switching.enterprise",
    description: "menu.label.switching.enterprise.description",
    url: [SiteId.Ui, "/switching/enterprise"],
    icon: {
      src: _externalAssets_Cx9aj6Rn__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_B8_Qr_az__default,
      width: 132,
      height: 80
    }
  }, {
    id: "switching-2.5/10-gbe-1u",
    label: "menu.label.switching.professional",
    description: "menu.label.switching.professional.description",
    url: [SiteId.Ui, "/switching/professional"],
    isNew: true,
    icon: {
      src: _externalAssets_B0X_t3Jf__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_BSkw9Zkq__default,
      width: 132,
      height: 80
    }
  }, {
    id: "switching-gbe-1u",
    label: "menu.label.switching.value",
    description: "menu.label.switching.value.description",
    url: [SiteId.Ui, "/switching/value"],
    icon: {
      src: _externalAssets_BbFiyURO__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_BfjuZnZh__default,
      width: 132,
      height: 80
    }
  }, {
    id: "switching-compact",
    label: "menu.label.switching.compact",
    description: "menu.label.switching.compact.description",
    url: [SiteId.Ui, "/switching/compact"],
    icon: {
      src: _externalAssets_Dn54mv2t__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_CIbMEIAi__default,
      width: 132,
      height: 80
    }
  }]
}, {
  id: "wifi" /* WiFi */,
  label: "menu.label.wifi",
  description: "menu.description.wifi",
  icon: {
    src: _externalAssets_hkQRamuJ__default,
    width: 37,
    height: 38
  },
  items: [{
    id: "wifi-overview",
    label: "commons.menu.label.overview",
    description: "menu.label.wifi.overview.description",
    collapsedLabel: "menu.label.wifi.overview",
    isOverview: true,
    hasDarkText: false,
    url: [SiteId.Ui, "/wifi"],
    icon: {
      src: _externalAssets_CRacVtRZ__default,
      height: 20,
      width: 32
    },
    image: {
      src: _externalAssets_Cpm3n_eb__default,
      width: 132,
      height: 80
    }
  }, {
    id: "wifi-enterprise",
    label: "menu.label.wifi.enterprise",
    description: "menu.label.wifi.enterprise.description",
    url: [SiteId.Ui, "/wifi/enterprise"],
    isNew: true,
    icon: {
      src: _externalAssets_DqAIRBTt__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_3KklAuCo__default,
      width: 128,
      height: 80
    }
  }, {
    id: "wifi-flagship",
    label: "menu.label.wifi.flagship",
    description: "menu.label.wifi.flagship.description",
    url: [SiteId.Ui, "/wifi/flagship"],
    isNew: true,
    icon: {
      src: _externalAssets_BpAHE3Kz__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_zRUCu0IR__default,
      width: 132,
      height: 80
    }
  }, {
    id: "wifi-wall",
    label: "menu.label.wifi.wall",
    description: "menu.label.wifi.wall.description",
    url: [SiteId.Ui, "/wifi/wall"],
    isNew: true,
    icon: {
      src: _externalAssets_NhqTXzWJ__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_D1txdweP__default,
      width: 132,
      height: 80
    }
  }, {
    id: "wifi-outdoor",
    label: "menu.label.wifi.outdoor",
    description: "menu.label.wifi.outdoor.description",
    url: [SiteId.Ui, "/wifi/outdoor"],
    isNew: true,
    icon: {
      src: _externalAssets_DoUzeQKl__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_C3btxvT0__default,
      width: 132,
      height: 80
    }
  },
  // {
  //   id: "wifi-mega-capacity",
  //   label: "menu.label.wifi.megaCapacity",
  //   description: "menu.label.wifi.megaCapacity.description",
  //   url: [SiteId.Ui, "/wifi/mega-capacity"],
  //   icon: {
  //     src: menuIcons.stadium,
  //     width: 40,
  //     height: 40,
  //   },
  //   image: {
  //     src: menuImages.WifiMegaCapacity,
  //     width: 132,
  //     height: 80,
  //   },
  // },
  {
    id: "wifi-bridging",
    label: "menu.label.wifi.bridging",
    description: "menu.label.wifi.bridging.description",
    url: [SiteId.Ui, "/wifi/bridging"],
    icon: {
      src: _externalAssets_CqhVoPUD__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets__VZ6$rD9__default,
      width: 132,
      height: 80
    }
  }]
}, {
  id: "physical-security" /* PhysicalSecurity */,
  label: "menu.label.physicalSecurity",
  description: "menu.description.physicalSecurity",
  icon: {
    src: _externalAssets_B_OBU6a1__default,
    width: 37,
    height: 38
  },
  items: [{
    id: "physical-security-overview",
    label: "commons.menu.label.overview",
    collapsedLabel: "commons.menu.label.overview",
    description: "menu.label.security.overview.description",
    isOverview: true,
    hasDarkText: false,
    url: [SiteId.Ui, "/physical-security"],
    icon: {
      src: _externalAssets_CRacVtRZ__default,
      height: 20,
      width: 32
    },
    image: {
      src: _externalAssets_CQnDr0KZ__default,
      width: 132,
      height: 80
    }
  }, {
    id: "physical-security-dome-turret",
    label: "menu.label.security.domeAndTurret",
    description: "menu.label.security.domeAndTurret.description",
    url: [SiteId.Ui, "/physical-security/dome-turret"],
    hasDarkText: false,
    isNew: true,
    icon: {
      src: _externalAssets_D2$2b9Kg__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_DSCcAWv8__default,
      width: 132,
      height: 80
    }
  }, {
    id: "physical-security-bullet",
    label: "menu.label.security.bullet",
    hasDarkText: false,
    description: "menu.label.security.bullet.description",
    url: [SiteId.Ui, "/physical-security/bullet"],
    isNew: true,
    icon: {
      src: _externalAssets_CJUPKRFm__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_DXDhtbGS__default,
      width: 132,
      height: 80
    }
  }, {
    id: "physical-security-ptz",
    label: "menu.label.security.ptz",
    hasDarkText: false,
    description: "menu.label.security.ptz.description",
    url: [SiteId.Ui, "/physical-security/ptz"],
    icon: {
      src: _externalAssets_BhTWNUe$__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_hQ45m3sS__default,
      width: 132,
      height: 80
    }
  }, {
    id: "physical-security-special-devices",
    label: "menu.label.security.specialDevices",
    hasDarkText: false,
    description: "menu.label.security.specialDevices.description",
    url: [SiteId.Ui, "/physical-security/special-devices/doorbells"],
    icon: {
      src: _externalAssets_h17pgRRZ__default,
      width: 40,
      height: 32
    },
    image: {
      src: _externalAssets_C_DozlA4__default,
      width: 132,
      height: 80
    },
    items: [{
      id: "physical-security-special-devices-doorbells",
      label: "menu.label.security.specialDevices.doorbells",
      url: [SiteId.Ui, "/physical-security/special-devices/doorbells"],
      icon: {
        src: _externalAssets_BJ4JezH6__default,
        width: 40,
        height: 40
      }
    }, {
      id: "physical-security-special-devices-compact-cameras",
      label: "menu.label.security.specialDevices.compactCameras",
      url: [SiteId.Ui, "/physical-security/special-devices/compact-cameras"],
      icon: {
        src: _externalAssets_TWdDoFCP__default,
        width: 40,
        height: 40
      }
    }, {
      id: "physical-security-special-devices-ai-enhancements",
      label: "menu.label.security.specialDevices.aiEnhancements",
      url: [SiteId.Ui, "/physical-security/special-devices/ai-enhancements"],
      icon: {
        src: _externalAssets_B4KkF36C__default,
        width: 40,
        height: 40
      }
    }, {
      id: "physical-security-special-devices-super-link",
      label: "menu.label.security.specialDevices.superLink",
      url: [SiteId.Ui, "/physical-security/special-devices/super-link"],
      icon: {
        src: _externalAssets_CgJ1WmE4__default,
        width: 40,
        height: 40
      }
    }, {
      id: "physical-security-special-devices-floodlight",
      label: "menu.label.security.specialDevices.floodlight",
      url: [SiteId.Ui, "/physical-security/special-devices/floodlight"],
      icon: {
        src: _externalAssets_CtJPud52__default,
        width: 40,
        height: 40
      }
    }]
  }, {
    id: "physical-security-video-recorders",
    label: "menu.label.security.videoRecorders",
    description: "menu.label.security.videoRecorders.description",
    hasDarkText: false,
    url: [SiteId.Ui, "/physical-security/video-recorders"],
    icon: {
      src: _externalAssets_T7rpQKbk__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_2tUH2ymR__default,
      width: 132,
      height: 80
    }
  }, {
    id: "physical-security-door-access",
    label: "menu.label.security.doorAccess",
    description: "menu.label.security.doorAccess.description.1",
    hasDarkText: false,
    url: [SiteId.Ui, "/physical-security/door-access"],
    icon: {
      src: _externalAssets_YNBtLHei__default,
      width: 50,
      height: 40
    },
    image: {
      src: _externalAssets_COisoUzw__default,
      width: 132,
      height: 80
    }
  }]
}, {
  id: "integrations" /* Integrations */,
  label: "menu.label.newIntegrations",
  description: "menu.description.integrations",
  icon: {
    src: _externalAssets_DJwY3ZXh__default,
    width: 37,
    height: 38
  },
  items: [{
    id: "new-integrations-unifi-drive",
    label: "menu.label.newIntegrations.unifiDrive",
    description: "menu.label.newIntegrations.unifiDrive.description",
    url: [SiteId.Ui, "/integrations/network-storage"],
    icon: {
      src: _externalAssets_CSNKwvWT__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_DNTZveo7__default,
      width: 132,
      height: 80
    }
  }, {
    id: "new-integrations-power-tech",
    label: "menu.label.newIntegrations.powerTech",
    description: "menu.label.newIntegrations.powerTech.description",
    url: [SiteId.Ui, "/integrations/power-tech/ups-solutions"],
    icon: {
      src: _externalAssets_iKcTrPwm__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_Cejg$63X__default,
      width: 132,
      height: 80
    },
    items: [{
      id: "new-integrations-power-tech-ups",
      label: "menu.label.newIntegrations.ups",
      url: [SiteId.Ui, "/integrations/power-tech/ups-solutions"],
      icon: {
        src: _externalAssets_iKcTrPwm__default,
        width: 40,
        height: 40
      }
    }, {
      id: "new-integrations-power-tech-power-solutions",
      label: "menu.label.newIntegrations.powerSolutions",
      url: [SiteId.Ui, "/integrations/power-tech/power-solutions"],
      icon: {
        src: _externalAssets_CVgHVDx___default,
        width: 40,
        height: 40
      }
    }]
  }, {
    id: "new-integrations-managed-voip",
    label: "menu.label.newIntegrations.managedVoip",
    description: "menu.label.newIntegrations.managedVoip.description",
    url: [SiteId.Ui, "/integrations/managed-voip"],
    icon: {
      src: _externalAssets_DPMNLIio__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_B_Cc27E8__default,
      width: 132,
      height: 80
    }
  }, {
    id: "new-integrations-mobile-routing",
    label: "menu.label.newIntegrations.mobileRouting",
    description: "menu.label.newIntegrations.mobileRouting.description",
    url: [SiteId.Ui, "/integrations/mobile-routing"],
    icon: {
      src: _externalAssets_GYevzP4Z__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_C5MQ_jlG__default,
      width: 132,
      height: 80
    }
  }, {
    id: "new-integrations-premium-iot",
    label: "menu.label.newIntegrations.premiumIoT",
    description: "menu.label.newIntegrations.premiumIoT.description",
    url: [SiteId.Ui, "/integrations/premium-iot/ev-charging"],
    icon: {
      src: _externalAssets_ChZQegFt__default,
      width: 40,
      height: 40
    },
    image: {
      src: _externalAssets_S4hTCKE4__default,
      width: 132,
      height: 80
    },
    items: [{
      id: "new-integrations-ev-charging",
      label: "menu.label.newIntegrations.evCharging",
      url: [SiteId.Ui, "/integrations/premium-iot/ev-charging"],
      icon: {
        src: _externalAssets_ChdEjBXM__default,
        width: 40,
        height: 40
      }
    }, {
      id: "new-integrations-digital-signage",
      label: "menu.label.newIntegrations.digitalSignage",
      url: [SiteId.Ui, "/integrations/premium-iot/digital-signage"],
      icon: {
        src: _externalAssets_Dr1plcD3__default,
        width: 40,
        height: 40
      }
    }, {
      id: "new-integrations-premium-audio",
      label: "menu.label.newIntegrations.premiumAudio",
      url: [SiteId.Ui, "/integrations/premium-iot/premium-audio"],
      icon: {
        src: _externalAssets_Gz$V$WE1__default,
        width: 40,
        height: 40
      }
    }]
  }, {
    id: "new-integrations-unifi-hosting",
    label: "menu.label.newIntegrations.hosting",
    description: "menu.label.newIntegrations.hosting.description",
    url: [SiteId.Ui, "/integrations/cloud-keys-gateways/control-plane-options"],
    icon: {
      src: _externalAssets_PsHlg1yq__default,
      width: 40,
      height: 32
    },
    image: {
      src: _externalAssets_BmQlds8B__default,
      width: 132,
      height: 80
    },
    items: [{
      id: "new-integrations-unifi-hosting-control-plane-options",
      label: "menu.label.newIntegrations.hosting.controlPlaneOptions",
      url: [SiteId.Ui, "/integrations/cloud-keys-gateways/control-plane-options"],
      icon: {
        src: _externalAssets_Ds50mgmi__default,
        width: 40,
        height: 40
      }
    }, {
      id: "new-integrations-unifi-hosting-independent-gateways",
      label: "menu.label.newIntegrations.hosting.independentGateways",
      url: [SiteId.Ui, "/integrations/cloud-keys-gateways/independent-gateways"],
      icon: {
        src: _externalAssets_pJK9fPl1__default,
        width: 40,
        height: 40
      }
    }]
  }, {
    id: "start-here-accessory-tech",
    label: "menu.label.newIntegrations.accessoryTech",
    description: "menu.label.newIntegrations.accessoryTech.description",
    url: [SiteId.Ui, "/integrations/accessory-tech"],
    icon: {
      src: _externalAssets_Ch5r_E58__default,
      width: 40,
      height: 32
    },
    image: {
      src: _externalAssets_Cw_GgD14__default,
      width: 132,
      height: 80
    },
    items: [{
      id: "start-here-accessory-tech-accessories",
      label: "menu.label.newIntegrations.accessoryTech.accessories",
      url: [SiteId.Ui, "/integrations/accessory-tech"],
      actionLabel: "commons.learnMore",
      image: {
        src: _externalAssets_BnbVVkSu__default
      },
      icon: {
        src: _externalAssets_Qic4gR$c__default,
        width: 40,
        height: 40
      }
    }, {
      id: "new-integrations-accessory-tech-internet-solutions",
      label: "menu.label.newIntegrations.internetSolutions.lteBackup",
      url: [SiteId.Ui, "/integrations/accessory-tech/internet-solutions"],
      actionLabel: "commons.learnMore",
      icon: {
        src: _externalAssets_B5qDlu7O__default,
        width: 40,
        height: 40
      },
      image: {
        src: _externalAssets_CjfieAUH__default
      }
    }, {
      id: "new-integrations-accessory-sfp-wizasrd",
      label: "menu.label.newIntegrations.internetSolutions.sfpWizard",
      url: [SiteId.Ui, "/integrations/accessory-tech/sfp-wizard"],
      actionLabel: "commons.learnMore",
      icon: {
        src: _externalAssets_DM_B33LN__default,
        width: 40,
        height: 40
      }
    }]
  }]
}];
const MICROSITE_HEADER_MAPPING = {
  id: "unifi",
  label: "menu.label.unifi",
  url: [SiteId.Ui, "/"],
  groups: [1],
  hasDarkText: true,
  items: [{
    id: START_HERE_ID,
    label: "menu.label.startHere",
    variant: "dropdown",
    items: [{
      id: "start-here-why-unifi",
      label: "menu.label.startHere.whyUniFi",
      items: [{
        id: "start-here-why-unifi-how-it-works-simple",
        label: "menu.label.startHere.whyUniFi.howItWorks.simple",
        url: [SiteId.Ui, "/how-it-works"],
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_DvVFinxL__default
        }
      }, {
        id: "start-here-why-unifi-how-it-works-large",
        label: "menu.label.startHere.whyUniFi.howItWorks.large",
        url: [SiteId.Ui, "/how-it-works/large"],
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_DiR0ROIn__default
        }
      }, {
        id: "start-here-why-unifi-how-it-works-massive-scale",
        label: "menu.label.startHere.whyUniFi.howItWorks.massiveScale",
        url: [SiteId.Ui, "/how-it-works/massive-scale"],
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_CQoXW_3n__default
        }
      }, {
        id: "start-here-why-unifi-how-it-works-multi-site",
        label: "menu.label.startHere.whyUniFi.howItWorks.multiSite",
        url: [SiteId.Ui, "/how-it-works/multi-site"],
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_vCVJ4SZf__default
        }
      }
      // {
      //   id: "start-here-why-unifi-migration-assistance",
      //   label: "menu.label.startHere.whyUniFi.migrationAssistance",
      //   description: "menu.description.startHere.whyUniFi.tcoCalculator",
      //   url: [SiteId.ExpertsUi, "/"],
      //   isExternalUrl: true,
      //   actionLabel: "commons.learnMore",
      //   image: { src: menuImages.WhyUniFiMigrationAssistant },
      // },
      ]
    }, {
      id: "start-here-resources",
      label: "menu.label.startHere.resources",
      items: [{
        id: "start-here-why-unifi-design-center",
        label: "menu.label.startHere.whyUniFi.designCenter",
        description: "menu.description.startHere.whyUniFi.tcoCalculator",
        url: ExternalUrl.DESIGN_CENTER,
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_QVv40$gv__default
        }
      }, {
        id: "start-here-resources-techspecs",
        label: "menu.label.startHere.resources.techSpecs",
        description: "menu.description.startHere.resources.techSpecs",
        url: ExternalUrl.TECH_SPECS,
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_C7zqcGfq__default
        }
      }, {
        id: "start-here-resources-pro-support",
        label: "menu.label.startHere.resources.proSupport",
        url: [SiteId.Ui, "/site-support"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_d0LZ7dCX__default
        }
      }, {
        id: "start-here-resources-blog",
        label: "menu.label.startHere.resources.blog",
        description: "menu.description.startHere.resources.blog",
        url: "https://blog.ui.com",
        isExternalUrl: true,
        actionLabel: "commons.viewAll",
        image: {
          src: _externalAssets_BAbiNnXu__default
        }
      }, {
        id: "start-here-resources-events-programs",
        label: "menu.label.startHere.resources.eventsPrograms",
        description: "menu.description.startHere.resources.eventsPrograms",
        url: [SiteId.Uwc, "/"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_BQseNU0v__default
        }
      }, {
        id: "start-here-resources-training",
        label: "menu.label.startHere.resources.training",
        description: "menu.description.startHere.resources.training",
        url: ExternalUrl.COURSES,
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_DeS__lyD__default
        }
      }, {
        id: "start-here-partner-hub",
        label: "menu.label.startHere.partnerHub",
        url: [SiteId.Ui, "/partner-hub"],
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_CyrW3sxr__default
        }
      }]
    }, {
      id: "start-here-case-studies",
      label: "menu.label.startHere.caseStudies",
      items: [{
        id: "start-here-case-studies-overview",
        label: "menu.label.startHere.caseStudies.unifiCaseStudies",
        description: "menu.description.startHere.caseStudies.unifiCaseStudies",
        url: [SiteId.CaseStudies, "/"],
        isExternalUrl: true,
        actionLabel: "commons.viewAll",
        image: {
          src: _externalAssets_CAFWLGY5__default,
          height: 146,
          width: 160
        }
      }, {
        id: "start-here-case-studies-shopify-summit",
        label: "menu.label.startHere.caseStudies.featured.shopifySummit",
        url: [SiteId.CaseStudies, "/case-study/delivering-connectivity-for-25-000-devices-at-shopify-summit-2025"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_DUdtRT_2__default,
          height: 146,
          width: 160
        }
      }, {
        id: "start-here-case-studies-tinyDino",
        label: "menu.label.startHere.caseStudies.featured.tinyDino",
        description: "menu.description.startHere.caseStudies.tinyDino",
        url: [SiteId.CaseStudies, "/case-study/tiny-dino-s-big-leap-high-performance-unifi-for-a-growing-agency"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_BZ1iDGY4__default,
          height: 146,
          width: 160
        }
      }, {
        id: "start-here-case-studies-celticDoyle",
        label: "menu.label.startHere.caseStudies.featured.celticDoyle",
        description: "menu.description.startHere.caseStudies.celticDoyle",
        url: [SiteId.CaseStudies, "/case-study/five-star-connectivity-doyle-collections-full-stack-unifi-deployment"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_DpNYEVxS__default,
          height: 146,
          width: 160
        }
      }, {
        id: "start-here-case-studies-fedex",
        label: "menu.label.startHere.caseStudies.featured.fedexForum",
        description: "menu.description.startHere.caseStudies.fedexForum",
        url: [SiteId.CaseStudies, "/case-study/fedex-forum-next-gen-arena-seamless-wifi-for-18-000-guests"],
        isExternalUrl: true,
        actionLabel: "commons.learnMore",
        image: {
          src: _externalAssets_r$Gidefk__default,
          height: 146,
          width: 160
        }
      }]
    }, {
      id: "start-here-site-map" /* SiteMap */,
      label: "menu.label.startHere.siteMap",
      variant: "column-list",
      items: SHARED_MENU_ITEMS.map(item => item.items ? {
        ...item,
        items: item.items.filter(item2 => !item2.id.includes("overview"))
      } : item)
    }]
  }, ...SHARED_MENU_ITEMS]
};
export { DEFAULT_LANGUAGE, MICROSITE_HEADER_MAPPING, MenuCategoryId, MenuItemId, SHARED_MENU_ITEMS, START_HERE_ID };
//# sourceMappingURL=mapping.mjs.map
